var ES6Promise = require("es6-promise");
ES6Promise.polyfill();
import axios from "axios";

export function saveTenderAsPdf(hash, productInfoTable, fileName) {
    const route = "/shared/tenders/" + hash + "/pdf";

    return axios.post(route, { productInfoTable: productInfoTable }, {
        responseType: 'blob'
    }).then(response => {
        var FileSaver = require('file-saver');
        var blob = new Blob([response.data], { type: "application/pdf" })
        FileSaver.saveAs(blob, fileName);
    }).catch(error => {
        console.log(error);
    });
}

export function saveOrderAsPdf(hash, productInfoTable, fileName) {
    const route = "/shared/orders/" + hash + "/pdf";

    return axios.post(route, { productInfoTable: productInfoTable }, {
        responseType: 'blob'
    }).then(response => {
        var FileSaver = require('file-saver');
        var blob = new Blob([response.data], { type: "application/pdf" })
        FileSaver.saveAs(blob, fileName);
    }).catch(error => {
        console.log(error);
    });
}